import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.83 7.84a.59.59 0 0 1 0 .23.83.83 0 0 0 0-.23Zm6.4.08a1.57 1.57 0 0 0-.89-1.15L3.56 1.61a1.66 1.66 0 0 0-1.62-.12 2 2 0 0 0-.69 1.79V6a1.36 1.36 0 0 0 1.33 1.5c.17 0 1 .26 2 .57-1 .31-1.82.54-2 .57a1.36 1.36 0 0 0-1.33 1.53v2.68a2 2 0 0 0 .69 1.8 1.23 1.23 0 0 0 .63.16 2.2 2.2 0 0 0 1-.29l9.78-5.16a1.55 1.55 0 0 0 .89-1.14.77.77 0 0 0 0-.15.39.39 0 0 0-.01-.15ZM2.86 13.2h-.09a3.53 3.53 0 0 1 0-.39v-2.68h.08c.44-.08 3.32-1 4.38-1.31a.35.35 0 0 0 .11 0 .7.7 0 0 0 .4-.28.54.54 0 0 0 .1-.2.59.59 0 0 0 0-.23.59.59 0 0 0 0-.23.54.54 0 0 0-.1-.2l-.08-.09-.09-.08a1 1 0 0 0-.21-.11h-.1C6.17 7 3.27 6.09 2.83 6h-.08V3.28a3.68 3.68 0 0 1 0-.39h.09l9.73 5.13Zm5-4.9a.78.78 0 0 0 0-.22.59.59 0 0 1-.04.22Z';
const draw24px =
  'M22.56,11.84a2.08,2.08,0,0,0-1.31-1.49L4.4,2.45a2.37,2.37,0,0,0-2.27-.14,2.64,2.64,0,0,0-.88,2.36V8.78c0,1.68,1.12,1.85,1.86,2L11.8,12,3.11,13.26c-.74.11-1.86.27-1.86,2v4.11a2.64,2.64,0,0,0,.88,2.36,1.58,1.58,0,0,0,.86.24,3.35,3.35,0,0,0,1.41-.39l16.85-7.89a2.08,2.08,0,0,0,1.31-1.49c0-.05,0-.11,0-.16A.86.86,0,0,0,22.56,11.84Zm-1.94.45L3.76,20.19a1.89,1.89,0,0,1-.78.24h0s-.18-.19-.18-1.1V15.22a1.17,1.17,0,0,1,0-.36,2.76,2.76,0,0,1,.54-.11l13.78-2L17,12l.11-.74-13.78-2c-.2,0-.48-.07-.53-.09a.9.9,0,0,1,0-.38V4.67c0-.92.18-1.09.18-1.09s.19-.07.83.23l16.86,7.9A1.3,1.3,0,0,1,21,12,1.43,1.43,0,0,1,20.62,12.29Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SendArrowIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'sendArrow'),
) as IconWithRender;

SendArrowIcon.displayName = 'SendArrowIcon';
SendArrowIcon.propTypes = Icon.propTypes;
SendArrowIcon.renderIcon = (props) => <SendArrowIcon {...props} />;
export default SendArrowIcon;
